import React from 'react';
import PropTypes from 'prop-types';
import { HereMapContext } from './here-map-context';
import { createInfoBubble, createRectangle } from '../../services/here-maps/here-map-wrapper';
import { makeShapeDynamic } from '../../services/here-maps/here-map-resizable-shapes';

export const HereMapRectangle = (props) => {
    const { pointA, pointB, strokeColor, type, changeable, onChanging, onChanged, children } = props;
    const context = React.useContext(HereMapContext);
    const instance = React.useRef({});

    React.useEffect(() => {
        return () => {
            instance.current.map?.removeObject(instance.current.rectangle);
            instance.current.rectangle = null;
        };
    }, []);

    React.useEffect(() => {
        instance.current = {
            ...instance.current,
            map: context.map,
            ui: context.ui,
            behavior: context.behavior
        };

        if (instance.current.map) {
            if (instance.current.rectangle) {
                instance.current.map.removeObject(instance.current.rectangle);
            }

            let rectangle = createRectangle(pointA, pointB, strokeColor, type);

            if (changeable) {
                rectangle = makeShapeDynamic(instance.current.map, instance.current.behavior, rectangle, strokeColor, onChanging, onChanged);
            }

            instance.current.rectangle = rectangle;
            instance.current.map.addObject(rectangle);

            if (children) {
                const infoBubble = createInfoBubble(pointA.lat, (pointA.lng + pointB.lng) / 2, children);
                infoBubble.setData({ isRectangleTooltip: true });

                rectangle.addEventListener('pointerenter', () => {
                    instance.current.ui.addBubble(infoBubble);
                });

                rectangle.addEventListener('pointerleave', () => {
                    const allBubbles = instance.current.ui.getBubbles();

                    if (allBubbles) {
                        allBubbles.map((bubble) => {
                            // don't want to remove all info bubbles, ie: when clicked on device and showing driver tooltip
                            if (bubble.getData()?.isRectangleTooltip) {
                                instance.current.ui.removeBubble(bubble);
                            }
                        })
                    }
                });
            }
        }
    }, [pointA, pointB, strokeColor, context.map]);

    return null;
};

HereMapRectangle.propTypes = {
    children: PropTypes.node,
    pointA: PropTypes.object,
    pointB: PropTypes.object,
    strokeColor: PropTypes.string,
    onClick: PropTypes.func,
    changeable: PropTypes.bool,
    onChanging: PropTypes.func,
    onChanged: PropTypes.func,
    type: PropTypes.string,
};
